var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerstarsLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 788 133",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "M.06.687h787.848V132.94H.06z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1_PSLogo_Neg_RGB"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ps-logo-pokerstars-word",
    fill: "#FFFFFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.346 56.101c0 12.272-7.906 20.771-23.079 20.771h-17.188V96.88H159.56V36.826h34.266c13.135 0 20.52 7.253 20.52 19.275m-15.111.17c0-5.758-3.692-8.077-9.101-8.077h-16.055V64.85h14.851c6.753 0 10.305-2.659 10.305-8.579",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.168 66.998c0 20.35-14.862 30.745-33.235 30.745-18.371 0-33.223-10.395-33.223-30.745 0-20.691 14.852-31.106 33.223-31.106 18.373 0 33.235 10.415 33.235 31.106m-15.454 0c0-12.794-7.815-19.065-17.781-18.975-9.962.091-17.77 6.272-17.77 18.975 0 12.361 7.816 18.724 17.77 18.724 9.955 0 17.781-6.272 17.781-18.724",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M320.68 72.156l-9.795 11.16v13.565h-14.539V36.826h14.509v28.375l25.337-28.375h18.062l-23.73 25.365 26.359 34.69h-17.952L320.68 72.156"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M379.094 48.866v11.609h29.701v11.47h-29.701v12.654h33.113V96.88h-47.632V36.825h47.632v12.041h-33.113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.751 75.326h-10.296v21.555h-14.519V36.824h34.869c13.988 0 20.433 8.027 20.433 18.555 0 9.692-5.41 17.058-14.6 18.974l17.858 22.578H463.9l-16.149-21.605zm-10.296-11.589h15.796c5.919 0 9.872-2.228 9.872-7.636 0-5.761-4.013-7.909-9.442-7.909h-16.226v15.545z",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.537 35.921a99.704 99.704 0 0121.643 2.148v12.532a97.2 97.2 0 00-22.646-2.658c-7.135 0-11.418 2.228-11.509 5.839-.091 3.614 2.317 5.229 7.726 5.579l11.509.684c11.932.692 18.975 6.181 18.975 17.599 0 15.283-12.962 20.069-27.733 20.069a129.081 129.081 0 01-22.409-2.147V82.711a112.27 112.27 0 0022.839 2.489c9.181 0 13.305-2.227 13.305-6.784 0-3.771-3.953-5.408-9.443-5.659l-9.53-.522c-11.853-.601-19.147-5.838-19.147-16.396-.029-13.908 11.65-19.918 26.42-19.918",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    d: "M598.279 49.317h-19.92v47.564h-14.511V49.317h-20.066V36.824h54.516l-.019 12.493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.193 84.427h-28.681l-4.805 12.453h-15.714l24.634-60.055h20.441l24.642 60.104h-15.711l-4.806-12.502zm-4.557-11.76l-9.786-25.246-9.79 25.246h19.576z",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.002 75.326h-10.304v21.555h-14.511V36.824h34.862c13.994 0 20.428 8.027 20.428 18.555 0 9.692-5.408 17.058-14.591 18.974l17.86 22.578h-17.609l-16.135-21.605zm-10.304-11.589h15.793c5.929 0 9.874-2.228 9.874-7.636 0-5.761-4.014-7.909-9.442-7.909h-16.225v15.545z",
    id: "Fill-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.777 35.921c7.286-.08 14.989.641 22.117 2.148v12.532c-7.424-1.773-15.467-2.666-23.101-2.658-7.124 0-11.416 2.228-11.507 5.839-.09 3.614 2.316 5.229 7.736 5.579l11.498.684c11.931.692 19.388 6.181 19.388 17.599 0 15.283-13.396 20.069-28.166 20.069-7.528-.05-15.037-.76-22.437-2.117V82.711a112.518 112.518 0 0022.837 2.489c9.191 0 13.305-2.227 13.305-6.784 0-3.771-3.943-5.408-9.443-5.659l-9.532-.522c-11.84-.601-19.176-5.838-19.176-16.344 0-13.96 11.711-19.97 26.481-19.97",
    id: "Fill-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.378 28.701C69.057 11.411 58.022.687 58.022.687S46.965 11.411 29.675 28.701C20.538 37.827 0 60.471 0 82.986c0 15.008 12.171 27.177 27.181 27.177 9.853 0 18.454-5.251 23.218-13.098v.008c.48-.586 1.263-1.066 2.143-1.066 1.399 0 2.671.986 2.524 2.208-1.047 8.097-5.606 28.046-23.573 34.785h53.044c-17.964-6.739-22.521-26.688-23.561-34.785-.156-1.222 1.127-2.208 2.524-2.208.861 0 1.654.48 2.134 1.066l.011-.008c4.744 7.847 13.354 13.098 23.206 13.098 15.002 0 27.182-12.169 27.182-27.177 0-22.515-20.538-45.159-29.655-54.285",
    id: "Fill-12",
    fill: "#D70022"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    fill: "#FFFFFE",
    d: "M58.021 28.748l7.36 22.681h23.855L69.937 65.451l7.379 22.679-19.295-14.021L38.727 88.13l7.368-22.679-19.306-14.022h23.873l7.359-22.681"
  })))));
}
SvgPokerstarsLogo.displayName = 'PokerstarsLogo';
export default SvgPokerstarsLogo;